<template>
    <div class="health-savvy-membership-benefit" :class="{
        'container': layout === 'empty',
        'pt-5': layout === 'empty',
        'pb-5': layout === 'empty'
    }">
        <h3 v-if="langCode === 'en_US'">
            Health Savvy Membership Benefits
        </h3>
        <h3 v-else-if="langCode === 'ms_MY'">
            Faedah-Faedah Keahlian Health Savvy
        </h3>
        <h3 v-else-if="langCode === 'zh_CN'">
            Health Savvy 会员福利
        </h3>

        <div class="mb-5">
            <template v-if="langCode === 'en_US'">
                <div>
                    <h5>1. Outpatient Clinic Benefits</h5>
                    <ul>
                        <li>Our panel clinics will cap outpatient consultation fees and prices of medicines, which agreed in between Health Savvy and partnering clinics.</li>
                        <li>Free life-time storage of digital medical records.</li>
                        <li>Manage family healthcare digitally.</li>
                        <li>24/7 multi-lingua online bot for handling your enquiries and services.</li>
                        <li>Multi-lingua mobile app keeping full control on both yourself and family health care.</li>
                    </ul>
                </div>
            </template>
            <template v-else-if="langCode === 'zh_CN'">
                <div>
                    <h5>1. 门诊福利</h5>
                    <ul>
                        <li>我们的合作诊所将限制门诊咨询费用和药品价格，因为Health Savvy 和合作诊所早已经协商规定的。</li>
                        <li>终身免费存储数字医疗记录。</li>
                        <li>以数字方式管理家庭医疗保健。</li>
                        <li>24小时并使用多种语言在线机器人来处理您的查询和服务。</li>
                        <li>多语言移动应用程序可以完全让您自由自在的监督自己和家人的医疗保健。</li>
                    </ul>
                </div>
            </template>
            <template v-else-if="langCode === 'ms_MY'">
                <div>
                    <h5>1. Faedah-Faedah Klinik Pesakit Luar</h5>
                    <ul>
                        <li>Klinik-klinik panel kami akan mengehadkan yuran perundingan para doktor dan juga mengawal harga-harga ubat mereka. Ini bermakna kos-kos rawatan dan perubatan akan dikira berdasarkan syarat-syarat yang telah dipersetujui di antara Health Savvy dan klinik-klinik panel, supaya ahli-ahli kami dapat menjimat wang mereka untuk jangka masa yang panjang.</li>
                        <li>Penyimpanan rekod-rekod kesihatan dalam talian secara seumur hidup dan percuma.</li>
                        <li>Meningkatkan mutu penjagaan kesihatan seluruh keluarga secara digital and percuma.</li>
                        <li>Bot dalam talian boleh mengendalikan pertanyaan dan perkhidmatan ahli-ahli secara 24 jam setiap hari, and ia juga berupaya memberi perkhidmatannya melalui Bahasa Melayu, Bahasa Inggeris and Bahasa Cina.</li>
                        <li>Aplikasi mudah alih berbilang bahasa memudahkan ahli-ahli kami mengawal dan menjaga kesihatan diri dan keluarga dengan lebih berkesan bila-bila masa.</li>
                    </ul>
                </div>
            </template>
        </div>
        <div class="mb-5">
            <template v-if="langCode === 'en_US'">
                <div>
                    <h5>2. Motor Insurance</h5>
                    <div class="mb-3">
                        <ul>
                            <li>Open an account with our sister company, Insure Savvy, to compare motor insurance premiums digitally and save annually.</li>
                            <li>Health Savvy members earn 1 Wowpoint for every RM1 motor premium paid. These Wowpoints can be used to offset expenses with selected merchants, both online and offline, offering thousands of services and goods. Watch the video for more details.</li>
                            <li>Health Savvy members can now reclaim 100% of the purchasing value of their paid motor insurance, effectively making their motor insurance policies FREE*.</li>
                            <li>Manage motor policy-related matters such as claims, policy changes, and 24/7 hotline support digitally through Insure Savvy's mobile app.</li>
                        </ul>
                    </div>
                    <div>
                        <a href="//client.insuresavvy.com.my/#/account/login" class="btn btn-primary btn-primary-insv" target="_blank">Register Insure Savvy Membership</a>

                        <div class="mt-4">
                            <p>
                                Compare motor insurance premiums before becoming a member (valid for motor insurance policies due within 2 months from the current date).
                            </p>

                            <a href="//client.insuresavvy.com.my/#/quotations/request-single" class="btn btn-primary btn-primary-insv" target="_blank">Compare Motor Premiums</a>
                        </div>
                        <div class="mt-4">
                            <p> Watch this video to understand motor insurance benefits.</p>

                            <a href="https://youtu.be/2apkpzoORQU?si=GisZ0jleN4Y7ppRu" class="btn btn-primary btn-primary-insv" target="_blank">Motor Insurance Video</a>
                        </div>
                    </div>

                    <div class="mt-4">
                        <p>*note : subject to terms and conditions of each purchase.</p>
                    </div>
                </div>
            </template>
            <template v-else-if="langCode === 'zh_CN'">
                <div>
                    <h5>2. 汽车保险</h5>
                    <div class="mb-3">
                        <ul>
                            <li>在我们的姐妹公司Insure Savvy开设账户，可以通过数字方式比较车险保费，每年节省开支。</li>
                            <li>Health Savvy会员每支付1马来西亚令吉的车险保费，将获得1个Wowpoint，用于抵消选择商家的线上和线下支出，提供各种不同的服务和商品。观看视频以了解更多详情。</li>
                            <li>现在，Health Savvy会员可以返还100%的支付车险保费的购买价值，有效地使他们的车险保单变成免费*。</li>
                            <li>通过Insure Savvy的手机应用程序，可以通过数字方式管理与车保险单相关的事项，如理赔、保单变更和全天候热线支持。</li>
                        </ul>

                    </div>
                    <div>

                        <a href="//client.insuresavvy.com.my/#/account/login" class="btn btn-primary btn-primary-insv" target="_blank">注册 Insure Savvy 会员</a>
                        <div class="mt-4">
                            <p>
                                在成为会员之前比较车险保费（适用于当前日期起2个月内到期的车险保单）。
                            </p>

                            <a href="//client.insuresavvy.com.my/#/quotations/request-single" class="btn btn-primary btn-primary-insv" target="_blank">比较车险价格</a>
                        </div>
                        <div class="mt-4">
                            <p>
                                观看该短视频了解机动车保险优惠的好处。
                            </p>

                            <a href="https://youtu.be/2apkpzoORQU?si=GisZ0jleN4Y7ppRu" class="btn btn-primary btn-primary-insv" target="_blank">车险视频 (英语)</a>
                        </div>
                    </div>

                    <div class="mt-4">
                        <p>*注意：受各项购买条款和条件约束。</p>
                    </div>
                </div>
            </template>
            <template v-else-if="langCode === 'ms_MY'">
                <div>
                    <h5>2. Insurans Motor</h5>
                    <div class="mb-3">
                        <ul>
                            <li>Buka akaun dengan syarikat adik kami, Insure Savvy, untuk membandingkan premium insurans motor secara digital dan menjimatkan setiap tahun.</li>
                            <li>Ahli Health Savvy akan mendapatkan 1 Wowpoint untuk setiap RM1 premium insurans motor yang dibayar. Wowpoint ini boleh digunakan untuk menampung perbelanjaan dengan peniaga-peniaga terpilih, sama ada dalam talian atau di kedai fizikal, yang menawarkan beribu-ribu perkhidmatan dan barangan. Tonton video untuk maklumat lanjut.</li>
                            <li>Ahli Health Savvy kini boleh mendapatkan semula 100% nilai pembelian insurans motor yang telah dibayar, menjadikan polisi insurans motor mereka secara efektif PERCUMA*.</li>
                            <li>Uruskan perkara berkaitan polisi motor, seperti tuntutan, perubahan polisi, dan sokongan talian 24/7 secara digital melalui aplikasi mudah alih Insure Savvy.</li>
                        </ul>
                    </div>
                    <div>
                        <a href="//client.insuresavvy.com.my/#/account/login" class="btn btn-primary btn-primary-insv" target="_blank">Mendaftar Keahlian Insure Savvy</a>

                        <div class="mt-4">
                            <p>
                                Bandingkan premium insurans motor sebelum menjadi ahli (tertakluk kepada polisi insurans motor yang tamat dalam masa 2 bulan dari tarikh semasa).
                            </p>

                            <a href="//client.insuresavvy.com.my/#/quotations/request-single" class="btn btn-primary btn-primary-insv" target="_blank">Bandingan Premium Motor</a>
                        </div>

                        <div class="mt-4">
                            <p>
                                Tonton video ini untuk memahami manfaat-manfaat tawaran insurans motor.
                            </p>

                            <a href="https://youtu.be/2apkpzoORQU?si=GisZ0jleN4Y7ppRu" class="btn btn-primary btn-primary-insv" target="_blank">Video Insurans Motor ( Inggeris )</a>
                        </div>
                    </div>

                    <div class="mt-4">
                        <p>*nota: tertakluk kepada terma dan syarat pembelian masing-masing.</p>
                    </div>
                </div>
            </template>
        </div>

        <!-- <div class="mb-5">
            <template v-if="langCode === 'en_US'">
                <div>
                    <h5>3. Pharmacy Products (Coming Soon)</h5>
                    <ul>
                        <li>Health Savvy members can enjoy discounts from our partnering pharmacy physician outlets, as well as its online store.</li>
                    </ul>
                </div>
            </template>
            <template v-else-if="langCode === 'zh_CN'">
                <div>
                    <h5>3. 药房产品（即将推出）</h5>
                    <ul>
                        <li>Health Savvy 会员可享受合作药房医师网点及其在线商店的折扣。</li>
                    </ul>
                </div>
            </template>
            <template v-else-if="langCode === 'ms_MY'">
                <div>
                    <h5>3. Produk-Produk Farmasi (Akan Datang)</h5>
                    <ul>
                        <li>Ahli-ahli Health Savvy boleh menikmati diskaun-diskaun daripada kedai-kedai farmasi yang terlantik, termasuk kedai farmasi dalam talian.</li>
                    </ul>
                </div>
            </template>
        </div> -->
    </div>
</template>

<script>
import languageCodes from '@/config/languageCodes';
export default {
    'name': 'HealthSavvyMemberBenefit',
    'computed': {
        layout () {
            return this.$route.meta.layout || '';
        },
        langCode () {
            const queryCode = this.$route.query.lang;

            if (languageCodes.includes(queryCode)) {
                return queryCode;
            }

            return languageCodes[0];
        },
        isMobileView () {
            return this.$route.name === 'app_health-savvy-membership';
        }
    },
    mounted () {
        if (this.isMobileView) {
            window.Tawk_API = window.Tawk_API || {};
            window.Tawk_API.onLoad = function () {
                window.Tawk_API.hideWidget();
            };
        }
    }
};
</script>
<style>
.health-savvy-membership-benefit {

}
</style>
